import { useEffect } from 'react'
import type { JSX } from 'react'
import { Outlet } from 'react-router-dom'

import { injectMetaViewportTag } from '~publish/helpers/injectMetaViewportTag'

const Settings = (): JSX.Element => {
  useEffect(() => {
    // The IA overhaul makes the app responsive, so the meta viewport tag stays
    // in place even after this component unmounts.
    injectMetaViewportTag()
  }, [])

  return <Outlet />
}

export default Settings
